import './Policy.css';

export default function TermsConditions() {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <h1>📜 Terms &amp; Conditions</h1>
        <p>Please read these terms carefully before using JustService24</p>
      </div>

      <div className="policy-container">

        <p>
          These Terms and Conditions govern your use of the website and the JustService mobile application (the "App"),
          and any related services offered by Onexvora Business Solutions, doing business as JustService24 ("we," "us," or "our").
          By accessing or using our Services, you agree to be bound by these Terms and Conditions. If you do not agree with these terms, please do not use our Services.
        </p>
        <p>
          These Terms and Conditions constitute a legally binding agreement. IF YOU DO NOT AGREE WITH THESE TERMS, THEN YOU ARE EXPRESSLY
          PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
        </p>
        <p>
          Changes to these Terms will become effective seven (7) days after notice is given, except for security updates and new functionality,
          which will be effective immediately. The Services are intended for users who are at least 18 years old.
        </p>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📋</div>
            <h2>1. Our Services</h2>
          </div>
          <p>
            The information provided when using the Services is not intended for distribution to or use by any person or entity in any jurisdiction
            where such distribution would be contrary to law or regulation. Those who choose to access the Services from other locations do so on
            their own initiative and are solely responsible for compliance with local laws.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">👔</div>
            <h2>1.1 Integration of Human Resources (HR) Feature</h2>
          </div>

          <p><strong>Terms &amp; Conditions for Employers</strong></p>
          <p><strong>Employer Eligibility</strong></p>
          <ul>
            <li>Employers must be legally authorized to hire employees.</li>
            <li>Employers must provide accurate business details and contact information.</li>
            <li>Employers must comply with all applicable labor laws and regulations.</li>
          </ul>
          <p><strong>Job Posting Guidelines</strong></p>
          <ul>
            <li>Employers must provide clear, accurate, and non-misleading job descriptions.</li>
            <li>Job listings must include details such as qualifications, salary range, and location.</li>
            <li>Employers must not post duplicate, fake, or misleading job listings.</li>
          </ul>
          <p><strong>Employer Responsibilities</strong></p>
          <ul>
            <li>Employers are responsible for the accuracy of job postings and candidate interactions.</li>
            <li>Employers must not collect fees from job seekers for employment opportunities.</li>
            <li>Employers must handle candidate data responsibly and comply with data protection laws.</li>
          </ul>
          <p><strong>Candidate Data Usage</strong></p>
          <ul>
            <li>Employers must use candidate data solely for recruitment purposes.</li>
            <li>Employers must not share, sell, or misuse candidate data.</li>
            <li>Employers must comply with candidate requests for data removal.</li>
          </ul>
          <p><strong>Prohibited Activities</strong></p>
          <ul>
            <li>Posting jobs that involve illegal, fraudulent, or unethical activities.</li>
            <li>Using automated tools or bots to collect candidate data.</li>
            <li>Harassing, misleading, or spamming job seekers.</li>
            <li>Violating intellectual property or privacy rights.</li>
          </ul>
          <p><strong>Account Suspension &amp; Termination</strong></p>
          <p>JustService24 reserves the right to suspend or terminate an employer's account without notice if:</p>
          <ul>
            <li>🚫 The employer violates these Terms &amp; Conditions.</li>
            <li>🚫 The employer engages in fraudulent, illegal, or unethical hiring practices.</li>
            <li>🚫 Multiple reports from job seekers indicate misconduct.</li>
          </ul>
          <p>Employers can request account deletion by contacting our support team.</p>

          <p><strong>Terms &amp; Conditions for Job Seekers</strong></p>
          <p><strong>Job Seeker Eligibility</strong></p>
          <ul>
            <li>Job seekers must be at least 18 years old to register and use the platform.</li>
            <li>Job seekers must provide accurate and complete information when applying for jobs.</li>
            <li>JustService24 reserves the right to verify job seekers' identity and qualifications.</li>
          </ul>
          <p><strong>Registration &amp; Profile</strong></p>
          <ul>
            <li>By registering, job seekers consent to sharing their profiles with employers.</li>
            <li>Job seekers are responsible for maintaining the confidentiality of their account credentials.</li>
            <li>Providing false or misleading information may result in account suspension.</li>
          </ul>
          <p><strong>Job Applications &amp; Interviews</strong></p>
          <ul>
            <li>JustService24 facilitates connections between job seekers and employers but does not guarantee employment.</li>
            <li>Employers have sole discretion in hiring decisions, and JustService24 is not liable for their actions.</li>
          </ul>
          <p><strong>Code of Conduct</strong></p>
          <ul>
            <li>Job seekers must maintain professionalism when interacting with employers.</li>
            <li>Fraud, misrepresentation, or inappropriate behavior may result in account suspension.</li>
            <li>Harassment, discrimination, or unethical behavior will not be tolerated.</li>
          </ul>
          <p><strong>No Employment Guarantee</strong></p>
          <ul>
            <li>Registration on JustService24 does not guarantee employment.</li>
            <li>Job seekers are responsible for evaluating job offers before accepting them.</li>
          </ul>
          <p><strong>Limitation of Liability</strong></p>
          <ul>
            <li>JustService24 is not responsible for disputes between job seekers and employers.</li>
            <li>We are not liable for any losses, damages, or consequences arising from job applications.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">©️</div>
            <h2>2. Intellectual Property Rights</h2>
          </div>
          <p><strong>Our Intellectual Property</strong></p>
          <p>
            We own or license all intellectual property rights in our Services, including all source code, databases, functionality, software,
            website designs, audio, video, text, photographs, and graphics (the "Content"), as well as trademarks, service marks, and logos (the "Marks").
          </p>
          <p><strong>Your Use of Our Services</strong></p>
          <p>
            We grant you a non-exclusive, non-transferable, revocable license to access and use the Services for personal, non-commercial, or internal
            business purposes. You may not copy, reproduce, sell, or otherwise exploit the Services, Content, or Marks for any commercial purpose
            without our express prior written permission.
          </p>
          <p><strong>Submissions</strong></p>
          <p>
            By submitting information or content ("Submissions") to us, you assign all intellectual property rights in such Submissions to us.
            We will own the Submissions and may use them for any lawful purpose without acknowledgment or compensation to you.
          </p>
          <p><strong>Contributions</strong></p>
          <p>
            By posting Contributions, you grant us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free,
            fully-paid, worldwide right and license to use, copy, reproduce, distribute, sell, publish, broadcast, and exploit your Contributions
            for any purpose, including commercial and advertising purposes.
          </p>
          <p><strong>Content Moderation</strong></p>
          <p>
            We reserve the right to remove or edit any Contributions at any time, without notice, for any reason. We may also suspend or terminate
            your account and report you to authorities. We have no obligation to monitor Contributions.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">👤</div>
            <h2>3. User Representations</h2>
          </div>
          <p>By using the Services, you represent and warrant that:</p>
          <ul>
            <li>All registration information you submit will be true, accurate, current, and complete.</li>
            <li>You will maintain the accuracy of such information and promptly update it as necessary.</li>
            <li>You have the legal capacity and agree to comply with these Terms.</li>
            <li>You are not a minor in the jurisdiction in which you reside.</li>
            <li>You will not access the Services through automated or non-human means, whether through a bot, script, or otherwise.</li>
            <li>You will not use the Services for any illegal or unauthorized purpose.</li>
            <li>Your use of the Services will not violate any applicable law or regulation.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📝</div>
            <h2>4. User Registration</h2>
          </div>
          <p>
            You may be required to register to use the Services. You agree to keep your password confidential and will be responsible for all use
            of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine it is
            inappropriate, obscene, or otherwise objectionable.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">💳</div>
            <h2>5. Purchases and Payment</h2>
          </div>
          <p>We accept the following forms of payment:</p>
          <ul>
            <li>Mastercard</li>
            <li>Visa</li>
            <li>PayPal</li>
            <li>UPI</li>
            <li>Debit card</li>
            <li>Credit card</li>
          </ul>
          <p>
            All payments shall be in Indian Rupee. You agree to provide current, complete, and accurate purchase and account information for all
            purchases. Sales tax will be added to the price of purchases as deemed required by us. We may change prices at any time and reserve
            the right to refuse any order placed through the Services.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🔁</div>
            <h2>6. Subscriptions</h2>
          </div>
          <p><strong>Billing and Renewal</strong></p>
          <ul>
            <li>Users can renew their subscription via the "My Account" section under "Subscription Details."</li>
            <li>Users will be notified via email and within the app 7 days prior to subscription expiration.</li>
            <li>Payments can be made through credit/debit cards, net banking, or other available payment gateways.</li>
            <li>Upon successful payment, users will receive a confirmation email with renewal details.</li>
            <li>If not renewed, advertisements will be removed and premium features will be lost.</li>
            <li>Reactivation is possible within 30 days of expiration; after that, a new subscription is required.</li>
          </ul>
          <p><strong>Cancellation</strong></p>
          <p>
            All purchases are non-refundable. You can cancel your subscription at any time by contacting us.
            Your cancellation will take effect at the end of the current paid term.
          </p>
          <p><strong>Fee Changes</strong></p>
          <p>We may change the subscription fee from time to time and will communicate any price changes in accordance with applicable law.</p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🚫</div>
            <h2>7. Prohibited Activities</h2>
          </div>
          <p>As a user of the Services, you agree not to:</p>
          <ul>
            <li>Systematically retrieve data to create a database or directory without written permission from us.</li>
            <li>Trick, defraud, or mislead us and other users, especially to learn sensitive account information.</li>
            <li>Circumvent, disable, or otherwise interfere with security-related features of the Services.</li>
            <li>Disparage, tarnish, or otherwise harm us and/or the Services.</li>
            <li>Use any information obtained from the Services to harass, abuse, or harm another person.</li>
            <li>Make improper use of our support services or submit false reports of abuse or misconduct.</li>
            <li>Upload or transmit viruses, Trojan horses, or other harmful material including spamming.</li>
            <li>Engage in any automated use of the system, including data mining, robots, or scraping tools.</li>
            <li>Delete the copyright or other proprietary rights notice from any Content.</li>
            <li>Attempt to impersonate another user or person.</li>
            <li>Interfere with, disrupt, or create an undue burden on the Services or connected networks.</li>
            <li>Harass, annoy, intimidate, or threaten any of our employees or agents.</li>
            <li>Decipher, decompile, disassemble, or reverse engineer any of the software comprising the Services.</li>
            <li>Use a buying agent or purchasing agent to make purchases on the Services.</li>
            <li>Use the Services as part of any effort to compete with us or for any revenue-generating commercial enterprise.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">✍️</div>
            <h2>8. User-Generated Content</h2>
          </div>
          <p>When you create or make available any Contributions, you represent and warrant that:</p>
          <ul>
            <li>Your Contributions do not infringe the proprietary rights of any third party.</li>
            <li>You are the creator and owner of or have the necessary licenses and permissions for your Contributions.</li>
            <li>Your Contributions are not false, inaccurate, or misleading.</li>
            <li>Your Contributions are not unsolicited advertising, spam, pyramid schemes, or chain letters.</li>
            <li>Your Contributions are not obscene, violent, harassing, libelous, or otherwise objectionable.</li>
            <li>Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.</li>
            <li>Your Contributions do not violate any applicable law, regulation, or third-party rights.</li>
            <li>Your Contributions do not include offensive comments connected to race, gender, national origin, or disability.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📄</div>
            <h2>9. Contribution License</h2>
          </div>
          <p>
            By posting your Contributions, you grant us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable,
            royalty-free, fully-paid, worldwide right and license to host, use, copy, reproduce, disclose, sell, publish, broadcast, store,
            publicly perform, publicly display, reformat, translate, transmit, and distribute such Contributions for any purpose, commercial,
            advertising, or otherwise.
          </p>
          <p>
            You retain full ownership of all of your Contributions. We are not liable for any statements or representations in your Contributions.
            We reserve the right to (1) edit or redact any Contributions; (2) re-categorize any Contributions; and (3) pre-screen or delete any
            Contributions at any time and for any reason, without notice.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">⭐</div>
            <h2>10. Guidelines for Reviews</h2>
          </div>
          <p>When posting a review, you must comply with the following:</p>
          <ul>
            <li>You should have firsthand experience with the person/entity being reviewed.</li>
            <li>Your reviews should not contain offensive, racist, or hateful language.</li>
            <li>Your reviews should not contain discriminatory references based on religion, race, gender, or disability.</li>
            <li>Your reviews should not contain references to illegal activity.</li>
            <li>You should not be affiliated with competitors if posting negative reviews.</li>
            <li>You may not post any false or misleading statements.</li>
            <li>You may not organize a campaign encouraging others to post reviews.</li>
          </ul>
          <p>We may accept, reject, or remove reviews in our sole discretion.</p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📱</div>
            <h2>11. Mobile Application License</h2>
          </div>
          <p>
            We grant you a revocable, non-exclusive, non-transferable, limited right to install and use the App on wireless electronic devices
            owned or controlled by you. You shall not:
          </p>
          <ul>
            <li>Decompile, reverse engineer, disassemble, or attempt to derive the source code of the App.</li>
            <li>Make any modification, adaptation, or derivative work from the App.</li>
            <li>Use the App for any revenue-generating endeavor or commercial enterprise.</li>
            <li>Make the App available over a network permitting access by multiple devices or users simultaneously.</li>
            <li>Use the App to send automated queries or unsolicited commercial email.</li>
            <li>Remove, alter, or obscure any proprietary notice posted by us or the licensors of the App.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">⚙️</div>
            <h2>12. Services Management</h2>
          </div>
          <p>We reserve the right, but not the obligation, to:</p>
          <ul>
            <li>Monitor the Services for violations of these Terms.</li>
            <li>Take appropriate legal action against anyone who violates the law or these Terms.</li>
            <li>Refuse, restrict access to, limit the availability of, or disable any of your Contributions.</li>
            <li>Remove from the Services or disable all files and content that are excessive in size or burdensome to our systems.</li>
            <li>Otherwise manage the Services to protect our rights and property.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🔒</div>
            <h2>13. Privacy Policy</h2>
          </div>
          <p>
            We care about data privacy and security. By using the Services, you agree to be bound by our Privacy Policy.
            The Services are hosted in India. If you access the Services from any other region, you expressly consent to have
            your data transferred to and processed in India.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🛡️</div>
            <h2>14. Copyright Infringements</h2>
          </div>
          <p>
            We respect the intellectual property rights of others. If you believe that any material available on or through the Services
            infringes upon any copyright you own or control, please immediately notify us using the contact information provided below.
            Please be advised that you may be held liable for damages if you make material misrepresentations in a notification.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">⏱️</div>
            <h2>15. Term and Termination</h2>
          </div>
          <p>
            These Terms shall remain in full force and effect while you use the Services. WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION
            AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES TO ANY PERSON FOR ANY REASON, INCLUDING FOR BREACH OF
            ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE
            YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME,
            WITHOUT WARNING, IN OUR SOLE DISCRETION.
          </p>
          <p>
            If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under
            your name, a fake or borrowed name, or the name of any third party.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🔄</div>
            <h2>16. Modifications and Interruptions</h2>
          </div>
          <p>
            We reserve the right to change, modify, or remove the contents of the Services at any time at our sole discretion without notice.
            We cannot guarantee the Services will be available at all times. We will not be liable for any loss, damage, or inconvenience
            caused by your inability to access or use the Services during any downtime or discontinuance.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🇮🇳</div>
            <h2>17. Governing Law</h2>
          </div>
          <p>
            These Terms shall be governed by and defined following the laws of India. Onexvora Business Solutions and yourself irrevocably
            consent that the courts of India shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these Terms.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">⚖️</div>
            <h2>18. Dispute Resolution</h2>
          </div>
          <p><strong>Informal Negotiations:</strong> The Parties agree to first attempt to negotiate any Dispute informally for at least thirty (30) days before initiating arbitration.</p>
          <p>
            <strong>Binding Arbitration:</strong> Any dispute shall be referred to and finally resolved by the Arbitration and Conciliation Act 1996,
            Governed by India. The number of arbitrators shall be three (3). The seat of arbitration shall be New Delhi, India.
            The language of the proceedings shall be Hindi.
          </p>
          <p><strong>Restrictions:</strong></p>
          <ul>
            <li>No arbitration shall be joined with any other proceeding.</li>
            <li>There is no right or authority for any Dispute to be arbitrated on a class-action basis.</li>
            <li>There is no right or authority for any Dispute to be brought in a representative capacity on behalf of the general public.</li>
          </ul>
          <p><strong>Exceptions:</strong> The following Disputes are not subject to arbitration:</p>
          <ul>
            <li>Any Disputes seeking to enforce or protect the validity of intellectual property rights of a Party.</li>
            <li>Any Dispute related to allegations of theft, piracy, invasion of privacy, or unauthorized use.</li>
            <li>Any claim for injunctive relief.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">✏️</div>
            <h2>19. Corrections</h2>
          </div>
          <p>
            There may be information on the Services that contains typographical errors, inaccuracies, or omissions. We reserve the right to
            correct any errors, inaccuracies, or omissions and to change or update the information on the Services at any time, without prior notice.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">⚠️</div>
            <h2>20. Disclaimer</h2>
          </div>
          <p>
            THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK.
            TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT. WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY:
          </p>
          <ul>
            <li>Errors, mistakes, or inaccuracies of content and materials.</li>
            <li>Personal injury or property damage resulting from your access to and use of the Services.</li>
            <li>Any unauthorized access to or use of our secure servers and personal or financial information stored therein.</li>
            <li>Any interruption or cessation of transmission to or from the Services.</li>
            <li>Any bugs, viruses, or Trojan horses transmitted through the Services by any third party.</li>
            <li>Any errors or omissions in any content or for any loss or damage incurred as a result of use of any content via the Services.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📉</div>
            <h2>21. Limitations of Liability</h2>
          </div>
          <p>
            IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
            CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA,
            OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🛡️</div>
            <h2>22. Indemnification</h2>
          </div>
          <p>You agree to defend, indemnify, and hold us harmless from and against any loss, damage, liability, claim, or demand, including reasonable attorneys' fees, made by any third party due to or arising out of:</p>
          <ul>
            <li>Your Contributions.</li>
            <li>Use of the Services.</li>
            <li>Breach of these Terms.</li>
            <li>Any breach of your representations and warranties set forth in these Terms.</li>
            <li>Your violation of the rights of a third party, including intellectual property rights.</li>
            <li>Any overt harmful act toward any other user of the Services.</li>
          </ul>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">💾</div>
            <h2>23. User Data</h2>
          </div>
          <p>
            We will maintain certain data that you transmit to the Services for the purpose of managing the performance of the Services.
            Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates
            to any activity you have undertaken using the Services. You agree that we shall have no liability to you for any loss or
            corruption of any such data.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📧</div>
            <h2>24. Electronic Communications</h2>
          </div>
          <p>
            Visiting the Services, sending us emails, and completing online forms constitute electronic communications. You consent to receive
            electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you
            electronically satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC
            SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📌</div>
            <h2>25. Miscellaneous</h2>
          </div>
          <p>
            These Terms and any policies or operating rules posted by us on the Services constitute the entire agreement between you and us.
            Our failure to exercise or enforce any right or provision of these Terms shall not operate as a waiver of such right or provision.
            We may assign any or all of our rights and obligations to others at any time. If any provision of these Terms is determined to be
            unlawful, void, or unenforceable, that provision is deemed severable and does not affect the validity of any remaining provisions.
          </p>
        </div>

        <div className="policy-contact-box">
          <h3>📬 Contact Us</h3>
          <p>For any questions, concerns, or disputes regarding these Terms &amp; Conditions, please contact us at:</p>
          <p>📧 Email: <a href="mailto:support@justservice24.com">support@justservice24.com</a></p>
          <p>🌐 Website: <a href="http://www.justservice24.com">www.justservice24.com</a></p>
          <p>🏢 Onexvora Business Solutions, India</p>
          <p>📞 Support: Mon–Sat, 10:00 AM – 6:00 PM</p>
          <p>By using our website and services, you acknowledge and agree to these Terms and Conditions.</p>
        </div>
      </div>
    </div>
  );
}
